import { handleColorType } from '@quizzach/styles';
import { useTheme } from 'styled-components';

export const Xcollab = ({
	size,
	color,
	className,
}: {
	size?: number;
	color?: string;
	className?: string;
}) => {
	const theme = useTheme();

	return (
		<svg
			width={size || '42'}
			height={size || '42'}
			viewBox='0 0 42 42'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
		>
			<path
				d='M2.70711 1.29289C2.31658 0.902369 1.68342 0.902369 1.29289 1.29289C0.902369 1.68342 0.902369 2.31658 1.29289 2.70711L19.5858 21L1.29289 39.2929C0.902369 39.6834 0.902369 40.3166 1.29289 40.7071C1.68342 41.0976 2.31658 41.0976 2.70711 40.7071L21 22.4142L39.2929 40.7071C39.6834 41.0976 40.3166 41.0976 40.7071 40.7071C41.0976 40.3166 41.0976 39.6834 40.7071 39.2929L22.4142 21L40.7071 2.70711C41.0976 2.31658 41.0976 1.68342 40.7071 1.29289C40.3166 0.902369 39.6834 0.902369 39.2929 1.29289L21 19.5858L2.70711 1.29289Z'
				fill={color ? handleColorType(color, theme) : '#00FFC2'}
			/>
		</svg>
	);
};
